var AdditionalHelper = function() {

  // Header Light Helper
  // Check if MetaNav and MainNav exists
  var $header = $("header .header");
  var $metaNav = $header.find(".metanav").length;
  var $mainNav = $header.find(".mainnav").length;

  if(!$metaNav && !$mainNav ) {
    $("body").addClass("header-light");
  }
};

export {AdditionalHelper};